import React from "react";
import { Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";
//catalyst tailwind
import { Input } from '../components/catalyst/input';
import { Heading } from '../components/catalyst/heading';
//img 
import EmailInvitation from '../img/email-invitation-affaire.png'


export const ColListeTransac = styled.div`
display:flex;
flex-direction:row;
gap:1rem;
flex-wrap:wrap;
justify-content:start;
@media all and (max-width: 768px) {
}
`;
export const InputLink = styled(Input)`
background-color:#dee2e6;
margin-top:.5rem;
`;


function Support(args, props, value, rest) {
    //console.log("args fiche", args);



    if (args.user !== null) {
        return (
            <Container>
                {/** AIDE ET SUPPORT */}
                <div className="flex w-full flex-wrap items-end justify-between gap-4 border-b border-zinc-950/10 pb-6 dark:border-white/10">
                    <Heading>Aide & support</Heading>
                </div>
                <div class="mt-4 grid grid-cols-1 md:grid-cols-2">
                    <section class="group relative -mx-4 p-6 hover:bg-slate-50 sm:mx-0 sm:rounded-3xl">
                        <div class="flex items-center">
                            <svg class="h-8 w-8 flex-none" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 28.25c7.155 0 13.25-5.88 13.25-12.75S23.155 2.75 16 2.75 2.75 8.63 2.75 15.5c0 2.73.962 5.302 2.57 7.413.177.231.257.525.2.81-.25 1.253-.632 2.519-1.212 3.545-.435.768-.094 1.904.782 1.797 1.545-.188 3.377-.758 5.043-1.707a1.09 1.09 0 0 1 .948-.064c1.531.614 3.194.956 4.919.956Z" fill="#F0F9FF"></path>
                                <path d="m11.081 27.294-.28.695.28-.695Zm-5.76-4.381.596-.455-.597.455h.001Zm.199.81-.736-.146.736.147v-.001ZM28.5 15.5c0 6.43-5.732 12-12.5 12V29c7.543 0 14-6.19 14-13.5h-1.5ZM16 3.5c6.768 0 12.5 5.57 12.5 12H30C30 8.19 23.543 2 16 2v1.5Zm-12.5 12c0-6.43 5.732-12 12.5-12V2C8.457 2 2 8.19 2 15.5h1.5Zm2.417 6.958C4.399 20.466 3.5 18.05 3.5 15.5H2c0 2.908 1.025 5.639 2.724 7.867l1.193-.909Zm-.957 5.18c.636-1.124 1.037-2.477 1.295-3.767l-1.47-.294c-.244 1.214-.605 2.393-1.13 3.322l1.305.738v.001Zm4.802-.932c-1.58.9-3.317 1.438-4.763 1.615l.182 1.489c1.644-.2 3.57-.803 5.323-1.8l-.742-1.304ZM16 27.5c-1.625 0-3.194-.322-4.64-.902l-.558 1.392A13.938 13.938 0 0 0 16 29v-1.5Zm-5.496.51a.343.343 0 0 1 .298-.02l.559-1.392a1.844 1.844 0 0 0-1.6.108l.743 1.304Zm-6.85-1.11a2.237 2.237 0 0 0-.147 1.863c.113.294.306.584.601.79.305.212.677.305 1.073.257l-.182-1.49a.164.164 0 0 1-.028.002h-.007.002c-.001 0-.03-.023-.058-.095a.74.74 0 0 1 .052-.59L3.655 26.9h-.001Zm1.07-3.533c.06.08.07.157.06.21l1.471.294a1.764 1.764 0 0 0-.338-1.413l-1.193.91v-.001Z" fill="#0EA5E9"></path>
                                <path d="M10.75 18.25h10.475m-10.475-5h10.475H10.75Z" stroke="#0EA5E9" stroke-width="1.5" stroke-linecap="round" strokeLinejoin="round"></path>
                            </svg>
                            <h2 class="ml-4 text-base font-semibold leading-7 text-slate-900">Besoin d'aide ?</h2>
                        </div>
                        <div class="my-4 max-w-none prose-a:relative prose-a:z-10 prose-sm prose prose-slate prose-a:font-semibold prose-a:text-sky-500 hover:prose-a:text-sky-600">
                            <p> Quelque chose ne fonctionne pas ? Vous ne trouvez pas de solution à votre problème ? Contactez-nous directement nous trouverons une solution ensemble.
                            </p>
                        </div>
                        <a class="text-sm font-semibold leading-6 text-sky-500 group-hover:text-sky-600" href="https://wa.me/0757831364" target="_blank" rel="noreferrer">
                            <span class="absolute inset-0 rounded-3xl"></span>
                            Débuter une discussion via whatsapp
                            <span aria-hidden="true">→</span>
                        </a>
                    </section>
                    <section class="group relative -mx-4 p-6 hover:bg-slate-50 sm:mx-0 sm:rounded-3xl">
                        <div class="flex items-center">
                            <svg class="h-8 w-8 flex-none" fill="none">
                                <path d="M16 29.25c7.318 0 13.25-5.932 13.25-13.25S23.318 2.75 16 2.75 2.75 8.682 2.75 16 8.682 29.25 16 29.25Z" fill="#F0F9FF" stroke="#0EA5E9" stroke-width="1.5"></path>
                                <path d="M16 22.25a6.25 6.25 0 1 0 0-12.5 6.25 6.25 0 0 0 0 12.5Z" fill="#fff" stroke="#0EA5E9" stroke-width="1.5"></path>
                                <path d="M6.5 6.5l5 5M25.5 6.5l-5 5M6.5 25.5l5-5M25.5 25.5l-5-5" stroke="#0EA5E9" stroke-width="1.5"></path>
                            </svg>
                            <h2 class="ml-4 text-base font-semibold leading-7 text-slate-900">Facturation</h2>
                        </div>
                        <div class="my-4 max-w-none prose-a:relative prose-a:z-10 prose-sm prose prose-slate prose-a:font-semibold prose-a:text-sky-500 hover:prose-a:text-sky-600">
                            <p>
                                Vous avez une question sur votre abonnement, une facture ou un reçu ? Ecrivez nous par mail, nous vous répondrons rapidement.
                            </p>
                        </div>
                        <a class="text-sm font-semibold leading-6 text-sky-500 group-hover:text-sky-600" href="mailto:contact@clotere.fr">
                            <span class="absolute inset-0 rounded-3xl"></span>
                            Envoyer nous un email
                            <span aria-hidden="true">→</span>
                        </a>
                    </section>
                </div>




                {/** LISTE FEATURE */}
                <Row className="d-flex align-self-start">
                    <p className="mt-10 mb-3 text-xl">Consultez notre documentation</p>

                    {/** gestion doc */}
                    <div class="mt-10 relative w-full bg-white p-5 shadow-sm ring-1 ring-gray-900/5  sm:rounded-lg">

                        <h2 class="text-xl font-bold tracking-tight md:text-xl">Gestion des documents</h2>
                        <div class="mt-4 grid divide-y divide-neutral-200">
                            <div class="py-4">
                                <details class="group">
                                    <summary class="flex cursor-pointer list-none justify-between font-bold">
                                        <span> Comment demander un document à un utilisateur ?</span>
                                        <span class="transition group-open:rotate-180">
                                            <svg fill="none" height="24" shape-rendering="geometricPrecision"
                                                stroke="currentColor" stroke-linecap="round" strokeLinejoin="round"
                                                stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                                <path d="M6 9l6 6 6-6"></path>
                                            </svg>
                                        </span>
                                    </summary>
                                    <p class="group-open:animate-fadeIn mt-3 text-neutral-800">
                                        Sélectionnez l'affaire depuis votre espace  <Link className="text-indigo-800" to="/app/affaires">Affaire</Link>, puis cliquez en haut à droite sur le bouton <b>"Demander un document"</b>.
                                        <br /><br />
                                        Votre client recevra ensuite un email, l'informant qu'un document est requis sur son espace client. Dès qu'il l'aura ajouté vous recevrez une notification.
                                        <br />
                                        Clotere s'occupe des relances jusqu'à l'ajout du document.
                                    </p>
                                </details>
                            </div>
                            <div class="py-4">
                                <details class="group">
                                    <summary class="flex cursor-pointer list-none justify-between font-bold">
                                        <span> Comment signaler un document non conforme ?</span>
                                        <span class="transition group-open:rotate-180">
                                            <svg fill="none" height="24" shape-rendering="geometricPrecision"
                                                stroke="currentColor" stroke-linecap="round" strokeLinejoin="round"
                                                stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                                <path d="M6 9l6 6 6-6"></path>
                                            </svg>
                                        </span>
                                    </summary>
                                    <p class="group-open:animate-fadeIn mt-3 text-neutral-800">
                                        Sélectionnez l'affaire depuis votre espace  <Link className="text-indigo-800" to="/app/affaires">Affaire</Link>, puis sélectionner l'onglet <b>"Documents à collecter"</b>.

                                        <br /><br />
                                        Cliquez ensuite sur le bouton <b>"Signaler"</b> du document en question. Ajoutez un message expliquant les raisons du refus de ce document.
                                        <br />
                                        Votre client recevra un email l'informant qu'une correction de sa part est nécessaire. Vous recevrez une notification lorsqu'il fera l'action.
                                    </p>
                                </details>
                            </div>
                            <div class="py-4">
                                <details class="group">
                                    <summary class="flex cursor-pointer list-none justify-between font-bold">
                                        <span> Où sont stockés les documents ?</span>
                                        <span class="transition group-open:rotate-180">
                                            <svg fill="none" height="24" shape-rendering="geometricPrecision"
                                                stroke="currentColor" stroke-linecap="round" strokeLinejoin="round"
                                                stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                                <path d="M6 9l6 6 6-6"></path>
                                            </svg>
                                        </span>
                                    </summary>
                                    <p class="group-open:animate-fadeIn mt-3 text-neutral-800">
                                        Tous les documents sont stockés sur les serveurs Clotere, et cryptés de bout en bout.
                                        <br />
                                        Cela signifie que Clotere n’a pas accès au contenu des documents : seuls vous et votre client y avez accès. Cette approche garantit la confidentialité des données ainsi que le respect du secret professionnel du notaire.
                                        <br /><br />
                                        Vous pouvez télécharger les documents pour les réutiliser dans vos outils métiers.
                                    </p>
                                </details>
                            </div>

                        </div>

                    </div>

                    {/** gestion honoraires */}
                    <div class="mt-10 relative w-full bg-white p-5 shadow-sm ring-1 ring-gray-900/5  sm:rounded-lg">

                        <h2 class="text-xl font-bold tracking-tight md:text-xl">Gestion des honoraires</h2>
                        <div class="mt-4 grid divide-y divide-neutral-200">
                            <div class="py-4">
                                <details class="group">
                                    <summary class="flex cursor-pointer list-none justify-between font-bold">
                                        <span> Comment fonctionne les honoraires sur Clotere ?</span>
                                        <span class="transition group-open:rotate-180">
                                            <svg fill="none" height="24" shape-rendering="geometricPrecision"
                                                stroke="currentColor" stroke-linecap="round" strokeLinejoin="round"
                                                stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                                <path d="M6 9l6 6 6-6"></path>
                                            </svg>
                                        </span>
                                    </summary>
                                    <p class="group-open:animate-fadeIn mt-3 text-neutral-800">
                                        Un 1er lien de paiement en ligne est généré pour chaque affaire crée sur Clotere.<br /><br />
                                        L'utilisateur paye en ligne Clotere, et nous reversont immédiatemment les honoraires au notaire. (Pour connaître les tarifs des démarches consultez notre documentation dans la rubrique Tarifs)
                                        <br /><br />
                                        Lorsque des honoraires supplémentaires sont nécessaires, il est possible de faire une demande d'honoraire depuis l'espace affaire.<br />
                                        <br /><br />Un lien de paiement en ligne est alors généré, et Clotere facture à l'utilisateur des frais de service allant jusqu'à 6%.
                                    </p>
                                </details>
                            </div>
                            <div class="py-4">
                                <details class="group">
                                    <summary class="flex cursor-pointer list-none justify-between font-bold">
                                        <span> Comment faire une demande d'honoraires ?</span>
                                        <span class="transition group-open:rotate-180">
                                            <svg fill="none" height="24" shape-rendering="geometricPrecision"
                                                stroke="currentColor" stroke-linecap="round" strokeLinejoin="round"
                                                stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                                <path d="M6 9l6 6 6-6"></path>
                                            </svg>
                                        </span>
                                    </summary>
                                    <p class="group-open:animate-fadeIn mt-3 text-neutral-800">
                                        Sélectionnez l'affaire depuis votre espace  <Link className="text-indigo-800" to="/app/affaires">Affaire</Link>, sélectionnez l'onglet <b>"Honoraires"</b>.

                                        <br /><br />
                                        Cliquez ensuite sur le bouton <b>"Ajouter une facture"</b>. Renseignez les informations obligatoires et personnalisez votre demande si besoin.
                                        <br />
                                        Votre client recevra un email l'informant de la demande de paiement et pourra réaliser un paiement en ligne.
                                    </p>
                                </details>
                            </div>
                            <div class="py-4">
                                <details class="group">
                                    <summary class="flex cursor-pointer list-none justify-between font-bold">
                                        <span> Comment Clotere sécurise les paiements ?</span>
                                        <span class="transition group-open:rotate-180">
                                            <svg fill="none" height="24" shape-rendering="geometricPrecision"
                                                stroke="currentColor" stroke-linecap="round" strokeLinejoin="round"
                                                stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                                <path d="M6 9l6 6 6-6"></path>
                                            </svg>
                                        </span>
                                    </summary>
                                    <p class="group-open:animate-fadeIn mt-3 text-neutral-800">
                                        Clotere utilise la technologie passwordless pour plus de sécurité sur les espaces clients. Votre client ne peut se connecter qu'avec un code reçu par mail, ce qui rend impossiblele piratage par mot de passe.
                                        <br/><br/>
                                        Les paiements sont gérés par notre partenaire Stripe, qui a été audité et certifié fournisseur de services de conformité PCI de niveau 1, ce qui implique un rapport de conformité annuel et des analyses et tests de sécurité réguliers. 
                                        <br/>Stripe chiffre tous les numéros de carte de crédit de ses clients et stocke séparément les informations de déchiffrement, de sorte qu'il ne peut pas accéder aux numéros de carte sans mesures supplémentaires. 
                                        <br/>L'entreprise exige également que toutes les transactions en ligne s'effectuent via le réseau HTTPS, plus sécurisé.
                                       
                                    </p>
                                </details>
                            </div>

                        </div>

                    </div>
                    {/** rdv*/}
                    <div class="mt-10 relative w-full bg-white p-5 shadow-sm ring-1 ring-gray-900/5  sm:rounded-lg">

                        <h2 class="text-xl font-bold tracking-tight md:text-xl">Planning et prise de rendez-vous</h2>
                        <div class="mt-4 grid divide-y divide-neutral-200">
                            <div class="py-4">
                                <details class="group">
                                    <summary class="flex cursor-pointer list-none justify-between font-bold">
                                        <span> Comment activer la prise de rendez-vous en ligne ?</span>
                                        <span class="transition group-open:rotate-180">
                                            <svg fill="none" height="24" shape-rendering="geometricPrecision"
                                                stroke="currentColor" stroke-linecap="round" strokeLinejoin="round"
                                                stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                                <path d="M6 9l6 6 6-6"></path>
                                            </svg>
                                        </span>
                                    </summary>
                                    <p class="group-open:animate-fadeIn mt-3 text-neutral-800">
                                        Pour activer la prise de rendez-vous vous devez avoir un abonnement actif (à vérifier dans <Link to="/app/profil">votre profil</Link> )
                                        <br /><br />
                                        Vous devez synchroniser votre agenda avec l'app Clotere. Pour cela rendez-vous dans le menu <Link className="text-indigo-800" to="/app/calendrier">Calendrier</Link> et cliquez sur :
                                        <ul>
                                            <li>• <b>Synchroniser mon agenda Google</b>, si vous êtes sur un calendrier Google Workspace</li>
                                            <li>• <b>Synchroniser mon agenda Outlook</b>, si vous êtes sur un calendrier Microsoft Outlook</li>
                                        </ul>
                                    </p>
                                </details>
                            </div>
                            <div class="py-4">
                                <details class="group">
                                    <summary class="flex cursor-pointer list-none justify-between font-bold">
                                        <span> Comment modifier un rendez-vous ?</span>
                                        <span class="transition group-open:rotate-180">
                                            <svg fill="none" height="24" shape-rendering="geometricPrecision"
                                                stroke="currentColor" stroke-linecap="round" strokeLinejoin="round"
                                                stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                                <path d="M6 9l6 6 6-6"></path>
                                            </svg>
                                        </span>
                                    </summary>
                                    <p class="group-open:animate-fadeIn mt-3 text-neutral-800">
                                        Lorsque qu'un utilisateur prends rendez-vous dans votre agenda, un évenement ce créer automatiquement dans votre calendrier outlook ou google.
                                        <br />
                                        Pour modifier l'horaire ou le type de rendez-vous rendez-vous directement dans votre calendrier.
                                    </p>
                                </details>
                            </div>
                            <div class="py-4">
                                <details class="group">
                                    <summary class="flex cursor-pointer list-none justify-between font-bold">
                                        <span> Comment annuler un rendez-vous ?</span>
                                        <span class="transition group-open:rotate-180">
                                            <svg fill="none" height="24" shape-rendering="geometricPrecision"
                                                stroke="currentColor" stroke-linecap="round" strokeLinejoin="round"
                                                stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                                <path d="M6 9l6 6 6-6"></path>
                                            </svg>
                                        </span>
                                    </summary>
                                    <p class="group-open:animate-fadeIn mt-3 text-neutral-800">
                                        Vous pouvez annuler un rendez-vous directement depuis le menu <Link className="text-indigo-800" to="/app/calendrier">Calendrier</Link>, en cliquant sur le bouton annuler de l'évenement.
                                    </p>
                                </details>
                            </div>

                        </div>

                    </div>
                   

                    {/** affaire */}
                    <div class="mt-10 relative w-full bg-white p-5 shadow-sm ring-1 ring-gray-900/5  sm:rounded-lg">

                        <h2 class="text-xl font-bold tracking-tight md:text-xl">Créer une affaire et inviter mon client sur Clotere</h2>
                        <div class="mt-4 grid divide-y divide-neutral-200">
                            <div class="py-4">
                                <details class="group">
                                    <summary class="flex cursor-pointer list-none justify-between font-bold">
                                        <span> Comment créer une affaire sur Clotere ?</span>
                                        <span class="transition group-open:rotate-180">
                                            <svg fill="none" height="24" shape-rendering="geometricPrecision"
                                                stroke="currentColor" stroke-linecap="round" strokeLinejoin="round"
                                                stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                                <path d="M6 9l6 6 6-6"></path>
                                            </svg>
                                        </span>
                                    </summary>
                                    <p class="group-open:animate-fadeIn mt-3 text-neutral-800">
                                        Pour créer une affaire, cliquez sur le bouton <b>"+ Nouvelle affaire"</b>, en haut à droite de votre tableau de bord.
                                        <br /><br />
                                        Vous devrez alors renseigner :
                                        <ul>
                                            <li>• Les informations au sujet des intervenants : le mail est obligatoire pour que l'invitation soit valide </li>
                                            <li>• Les détails sur la démarche : nous permettant de personnaliser les espaces clients </li>
                                        </ul>
                                        <br /><br />
                                        Après votre validation, votre client recevra pas email une invitation à rejoindre son espace client Clotere, pour compléter son dossier.
                                        <br />
                                        Vous verrez votre affaire dans la liste de vos affaires sur votre espace notaire.
                                    </p>
                                </details>
                            </div>
                            <div class="py-4">
                                <details class="group">
                                    <summary class="flex cursor-pointer list-none justify-between font-bold">
                                        <span> Comment personnaliser le mail envoyé à mon client ?</span>
                                        <span class="transition group-open:rotate-180">
                                            <svg fill="none" height="24" shape-rendering="geometricPrecision"
                                                stroke="currentColor" stroke-linecap="round" strokeLinejoin="round"
                                                stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                                <path d="M6 9l6 6 6-6"></path>
                                            </svg>
                                        </span>
                                    </summary>
                                    <p class="group-open:animate-fadeIn mt-3 text-neutral-800">
                                        Lorsque vous ajoutez un intervenant au moment de la création de l'affaire, vous pouvez modifier le contenu du mail qui sera envoyé à votre client.

                                    </p>
                                </details>
                            </div>
                            <div class="py-4">
                                <details class="group">
                                    <summary class="flex cursor-pointer list-none justify-between font-bold">
                                        <span> Puis-je ajouter un intervenant plus tard ?</span>
                                        <span class="transition group-open:rotate-180">
                                            <svg fill="none" height="24" shape-rendering="geometricPrecision"
                                                stroke="currentColor" stroke-linecap="round" strokeLinejoin="round"
                                                stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                                <path d="M6 9l6 6 6-6"></path>
                                            </svg>
                                        </span>
                                    </summary>
                                    <p class="group-open:animate-fadeIn mt-3 text-neutral-800">
                                        Oui vous pourrez ajouter un intervenant directement depuis votre affaire. En cliquant en haut à droite de votre écran, sur le bouton <b>"+ Ajouter un intervenant"</b>.
                                        <br /><br />
                                        Vous pourrez alors personnaliser l'email d'invitation et demander des documents spécifiques.

                                    </p>
                                </details>
                            </div>
                            <div class="py-4">
                                <details class="group">
                                    <summary class="flex cursor-pointer list-none justify-between font-bold">
                                        <span> A quoi ressemble l'email reçu par les intervenants ?</span>
                                        <span class="transition group-open:rotate-180">
                                            <svg fill="none" height="24" shape-rendering="geometricPrecision"
                                                stroke="currentColor" stroke-linecap="round" strokeLinejoin="round"
                                                stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                                <path d="M6 9l6 6 6-6"></path>
                                            </svg>
                                        </span>
                                    </summary>
                                    <p class="group-open:animate-fadeIn mt-3 text-neutral-800">
                                        Voici l'email que reçoivent les intervenants que vous ajouter à une affaire :
                                        <img src={EmailInvitation} alt="message d'invitation" className="w-full sm:w-3/6 mx-auto mt-4" />

                                    </p>
                                </details>
                            </div>
                        </div>

                    </div>


                </Row>
            </Container>
        )
    }
}

export default Support;